import React, {Component} from "react";

/**
 * Sort errors before everything else..
 * TODO.. can we reduce the aName/bName to a common
 * comparison function?
 */
function sortTestResults(a, b) {
  if (a.testErrors !== null && b.testErrors === null)
    return -1;
  if (a.testErrors === null && b.testErrors !== null)
    return 1;

  var aName = a.className + a.testName;
  var bName = b.className + b.testName;
  if (aName < bName)
    return -1;
  if (aName > bName)
    return 1;
  return 0;
}

export class TestResultTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      results: this.buildAndSortResults(props.results),
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({results: this.buildAndSortResults(nextProps.results)})
  }

  /*
   * Create the sorted array of test results. A record with
   * {className, testName, testErrors}
   */
  buildAndSortResults(result) {
    if (result === null)
      return null;

    var results = []
    result.forEach(function(entry) {
      var mapped = entry.tests.map(function(test) {
          var failErrors = [];
          var addError = false;
          if (test.failures != null) {
            failErrors = failErrors.concat(test.failures);
            addError = true;
          }
          if (test.errors != null) {
            failErrors = failErrors.concat(test.errors);
            addError = true;
          }
          return {
            className: test.className,
            testName: test.testName,
            testErrors: addError ? failErrors : null,
            duration: test.duration,
          }
      });
      results = results.concat(mapped);
    });
    results.sort(sortTestResults);
    return results;
  }

  expandable(errors) {
      if (errors === null)
        return "";
      return "fa fa-fw fa-plus";
  }

  colorClass(test) {
    if (test.testErrors === null)
      return "success";
    return "warning";
  }

  buildDetails(test, row) {
    if (test.testErrors === null)
      return null;
    var i = 0;
    return (
      <tr className="warning test-details hidden" key={row+ "details"}><td colSpan="2">
        {
          test.testErrors.map(function(log) {
            i += 1;
            return (
                <span key={i} className="test-error-details">{log.text}</span>
            );
          })
        }
      </td></tr>);
  }

  handleClick(ev) {
    var result = ev.target.closest("tr");
    var details = result.nextSibling;
    var i = result.querySelector("i");

    /* fun to see if this is the right kind of node...*/
    if (!details.classList.contains("test-details"))
      return;

    if (details.classList.contains("hidden")) {
      details.classList.remove("hidden");
      i.classList.remove("fa-plus");
      i.classList.add("fa-minus");
    } else {
      details.classList.add("hidden")
      i.classList.remove("fa-minus");
      i.classList.add("fa-plus");
    }
  }

  /*
   * Return table rows with class/test and maybe an additional
   * row with details...
   */
  buildTestResults(results) {
    if (results == null)
      return null;

    var i = 0;
    return results.map(function(test) {
          i += 1;
          var elements = []
          const details = this.buildDetails(test, i);
          elements.push(
            <tr key={i} className={this.colorClass(test)} onClick={this.handleClick}>
              <td><i className={this.expandable(details)}></i>{test.className}</td>
              <td>{test.testName}</td>
              <td>{test.duration / 1000.0 / 1000.0} ms</td>
            </tr>
          );
          if (details !== null)
            elements.push(details);
          return elements;
      }.bind(this));
  }

  render() {
      const testResults = this.buildTestResults(this.state.results);
      return (
          <table className="table">
          <thead>
            <tr>
              <td>Class Name</td>
              <td>Test Name</td>
              <td>Test Duration</td>
            </tr>
          </thead>
          <tbody>
          {testResults}
          </tbody></table>
      );
  }

}



// WEBPACK FOOTER //
// ./src/components/TestResultTable.js